// extracted by mini-css-extract-plugin
export default {"nav":"DashboardWrapper_nav__d0aZ-","logo":"DashboardWrapper_logo__Y2rLP"};